import { createApi } from '@reduxjs/toolkit/query/react';
import { clientKeyBaseQuery } from '../cc/clientKeyBaseQuery';
import { SEARCH_API_TAG_LIST } from './constants';
/**
 * Base RTK Query API slice for the Search API.
 *
 * Uses `client-key` auth (not Bearer), so the `Authorization` header is injected
 * per-request in each endpoint's `query` builder rather than in `prepareHeaders`.
 * The `clientKey` is dynamic (fetched at runtime per area/collection) and must
 * be passed as an argument to every endpoint.
 *
 * The `X-Groupby-Customer-Id` header and common defaults are handled by
 * `clientKeyBaseQuery` so endpoints don't need to repeat them.
 *
 * Specific endpoint sets are added via `injectEndpoints`:
 * - `src/store/api/search/commonSearchApi.ts` — shared preview/search endpoints
 * - `src/store/api/search/evaluateSearchApi.ts` — evaluate-specific search endpoint
 */
export const searchApi = createApi({
    reducerPath: 'searchApi',
    baseQuery: clientKeyBaseQuery,
    tagTypes: SEARCH_API_TAG_LIST,
    endpoints: () => ({}),
});
